module.exports = __webpack_public_path__ + "img/Character_Candace_Thumb.3c91f95a.png";